import { FC } from 'react';
import { Routes, Route } from 'react-router-dom';
import NotFoundView from './views/404';
import AutoPlayView from './views/Autoplay';
import DeviceHandle from './views/Device';
import DMSearchView from './views/DMSearch';
import ImageMapView from './views/ImageMap';
import MapView from './views/Map';
import MediaGalleryView from './views/MediaGallery';
import MosaicView from './views/Mosaic';
import FlipBookView from './views/FlipBook';
import PreviewView from './views/Preview';
import SimulatorView from './views/Simulator';
import SingleView from './views/Single';
import SplashScreen from './views/SplashScreen';
import TimelineView from './views/Timeline';
import UrlHost from './views/UrlHost';

export interface ContainerProps {
  children: any
}

const RouteDeclaration: FC = () => {
  return (
    <>
      { /* Keep these pages always alive */}
      <UrlHost/>

      <Routes>
        <Route path="/" element={<SplashScreen />}/>
        <Route path="/simulator" element={<SimulatorView/>}/>
        <Route path="/simulator/:deviceId" element={<SimulatorView/>}/>
        <Route path="/device/:deviceId" element={<DeviceHandle/>}/>
        <Route path="/device/:deviceId/single/:documentId" element={<SingleView/>}/>
        <Route path="/device/:deviceId/article/:documentId" element={<SingleView/>}/>
        <Route path="/device/:deviceId/list/:documentId" element={<MosaicView/>}/>
        <Route path="/device/:deviceId/mosaic/:documentId" element={<MosaicView/>}/>
        <Route path="/device/:deviceId/timeline/:documentId" element={<TimelineView/>}/>
        <Route path="/device/:deviceId/imagemap/:documentId" element={ <ImageMapView/>}/>
        <Route path="/device/:deviceId/map/:documentId" element={<MapView/>}/>
        <Route path="/device/:deviceId/gallery/:documentId" element={<MediaGalleryView/>}/>
        <Route path="/device/:deviceId/autoplay/:documentId" element={<AutoPlayView/>}/>
        <Route path="/device/:deviceId/flipbook/:documentId" element={<FlipBookView/>}/>
        <Route path="/device/:deviceId/dm/:documentId" element={<DMSearchView/>}/>
        <Route path="/device/:deviceId/dm/:documentId/:contextId" element={<DMSearchView/>}/>
        <Route path="/device/:deviceId/url/:documentId" element={null}/>
        <Route path="/preview" element={<PreviewView/>}/>
        <Route path="*" element={<NotFoundView/>}/>
      </Routes>
    </>
  );
};

export default RouteDeclaration;
